var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondGraphicFive1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.073 2.15241L2 120.225L120.073 238.298L238.145 120.225L120.073 2.15241Z",
    stroke: "#8D46D1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondGraphicFive1);
export default __webpack_public_path__ + "static/media/diamond-graphic-five-1.dca4222e49fd60f22c39835f610c988f.svg";
export { ForwardRef as ReactComponent };